export interface FaContentServiceV1 {
  content: Content;
}

export type Content = object | undefined;

export class FaContentServiceV1Impl implements FaContentServiceV1 {
  public content: Content;
}
